import React, { Component, ReactNode } from 'react';
import { Dialog } from 'primereact/dialog';
import Icon from '../../../icons/Icon';
import EntityChatContentComponent from './EntityChatContentComponent';
import { query, repository, subscribe } from '@trlogic/client-js';
import { TransactionChatLog } from '../../../domain/case/CaseDomains';
import NavigationUtil from '../../../util/NavigationUtil';
import { InstanceContainer } from '../../../config/binding/InstanceBinding';
import Injectables from '../../../constant/Injectables';
import { EntityData } from '../../../domain/stream/transaction/EntityDomains';
import Computation = subscribe.Computation;
import SubscriptionContext = subscribe.SubscriptionContext;
import QueryBuilder = query.QueryBuilder;
import eq = query.eq;
import LanguageUtil from '../../../util/LanguageUtil';

class EntityChatComponent extends Component<Props, State> {
  public state: State = new State();

  private repository: repository.ReadOnlyQueryableRepository = InstanceContainer.get(Injectables.REPOSITORY);

  private computation: Computation | undefined;
  private readonly subscriptionContext: SubscriptionContext = InstanceContainer.get(Injectables.SUBSCRIPTION_CONTEXT);

  public render(): ReactNode {
    const { visible, onClose } = this.props;
    return (
      <Dialog
        header={this.getHeader}
        className={'case-attachment w-2/5 h-3/5'}
        visible={visible}
        onHide={() => {
          this.stopTracker();
          onClose();
        }}
        closable={false}
        closeOnEscape={true}
        dismissableMask={true}
      >
        {this.getContent()}
      </Dialog>
    );
  }

  public componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>) {
    if (prevProps.visible !== this.props.visible && this.props.visible) {
      this.startTracker();
    }
  }

  private startTracker = () => {
    const collections = this.subscriptionContext.getSubscriptionsByCollection(this.getEndpoint());
    this.computation = subscribe.Tracker.autorun(this.tracker, collections);
  };

  private tracker = () => {
    this.buildCommentLog();
  };

  private stopTracker = () => {
    this.computation?.stop();
  };

  private buildCommentLog = async () => {
    const chats = await this.repository.findMany<TransactionChatLog>(this.getQuery());
    this.setState({ chats });
  };

  private getEndpoint = () => {
    return `entity_chat_log_${NavigationUtil.getTenant()}`;
  };

  private getQuery = () => {
    const endpoint = this.getEndpoint();
    return QueryBuilder.select()
      .where(eq('transactionId', this.props.selectedEntity?.id))
      .from(endpoint)
      .limit(1000)
      .orderBy({
        field: 'timestamp',
        operator: 'ASC',
      })
      .build();
  };

  private getHeader = () => {
    return (
      <div className={'bg-[#333333] h-[54px] rounded-t-[6px] flex items-center justify-between align-center pl-[20px] pr-[20px]'}>
        <div className={'flex items-center justify-start align-center w-full lg:w-auto gap-2'}>
          <div className={'bg-white rounded-full w-[34px] h-[34px] min-h-[34px] min-w-[34px] shrink-0 flex justify-center align-center'}>
            <div className={'text-f-purple'}>
              <Icon icon={'comment'} size={20} />
            </div>
          </div>
          <div className={'text-white font-bold text-md'}>{LanguageUtil.get({ id: 'pages.entity.chat.title', defaultMessage: 'Chat' })}</div>
        </div>
      </div>
    );
  };

  private getContent = () => {
    const { chats } = this.state;
    const { domain, selectedEntity, updateEntity } = this.props;
    return <EntityChatContentComponent domain={domain} selectedEntity={selectedEntity} chats={chats} updateEntity={updateEntity} />;
  };
}

class State {
  chats: TransactionChatLog[] = [];
}

interface Props {
  visible: boolean;
  onClose: () => void;
  domain: string | undefined;
  selectedEntity: EntityData | undefined;
  updateEntity: () => void;
}

export default EntityChatComponent;
